<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :onFormSubmit="handleSubmit"
    title="客户"
    resource="formal_accounts"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend } from '@/admin_grapes/formal_accounts.js';
import { formColumnsExtend } from '@/admin_grapes/accounts.js';
import { columnsExtend as accountFundColumnsExtend } from '@/admin_entities/account_fund_detail.js';
import _ from 'lodash';
import { abilityService } from 'beans-admin-plugin';
import { linkTo } from '@/custom_columns_extend';

@Component
export default class FormalAccounts extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  get agentTargetIdRenderCell() {
    return {
      props: {
        xRemotePreload: async () => {
          const { data } = await this.$request.get('/accounts/read_options', { per_page: 100, type_in: ['PersonalAccount', 'ProductAccount', 'CompanyAccount'] });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const { data } = await this.$request.get('/accounts/read_options', { keyword, type_in: ['PersonalAccount', 'ProductAccount', 'CompanyAccount'] });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const accountFundColumns = accountFundColumnsExtend([
      {
        key: 'already_video_record',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return <bean-link keepNode to={{ name: 'video_records.index', query: { account_id_eq: row.account_id } }} can={'video_records.read'}>{value ? '是' : '否' }</bean-link>
        }
      },
      {
        key: 'fund',
        width: 200,
      },
      {
        prop: 'revenue_datum.net_investment',
        label: '净投入',
        renderCell: 'money',
        width: 120,
      },
      {
        prop: 'revenue_datum.total_capital',
        label: '最新资产',
        renderCell: 'money',
        width: 120,
      },
      {
        prop: 'revenue_datum.total_share',
        label: '最新份额',
        renderCell: 'money',
      },
      {
        prop: 'fund.latest_fund_value.value',
        label: '最新净值',
        renderCell: 'netValue',
      },
      {
        prop: 'revenue_datum.accumulative_return',
        label: '投资收益',
        renderCell: 'money',
        width: 120,
      },
      {
        key: 'last_confirm_date',
        width: 120,
      },
    ])

    const array = [
      type === 'show' && 'id',
      'type',
      'name',
      {
        key: 'number',
        width: 200,
      },
      'user',
      {
        key: 'account_status',
        renderCell: (h, { props: { value } }) => {
          return <el-tag type="primary">{this.$t(`account.accountStatuses.${value}`)}</el-tag>;
        }
      },
      {
        key: 'risk_assessment_level',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return <bean-link keepNode to={{ name: 'risk_assessment_results.index', query: { account_id_eq: row.id } }} can={'risk_assessment_results.read'}>{this.$t(`account.riskAssessmentLevels.${value}`)}</bean-link>
        }
      },
      {
        key: 'has_video_records',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'video_records.index', query: { account_id_eq: row.id } }} can={'video_records.read'}>是</bean-link>
          }
          return <bean-link keepNode to={{ name: 'video_records.new' }} can={'video_records.create'}>否</bean-link>
        }
      },
      {
        prop: 'trade_account_account_funds',
        label: '产品',
        minWidth: 920,
        filterColumns: filterColumnsExtend([
          'trade_account_account_funds_already_video_record_eq',
          'trade_account_account_funds_fund_id_eq',
          {
            key: 'trade_account_account_funds_amount_gteq',
            label: `${this.$t('accountFund.amount')}大于等于`
          },
          {
            key: 'trade_account_account_funds_amount_lteq',
            label: `${this.$t('accountFund.amount')}小于等于`
          },
          {
            key: 'trade_account_account_funds_last_confirm_date_gteq',
            label: `${this.$t('accountFund.lastConfirmDate')}大于等于`
          },
          {
            key: 'trade_account_account_funds_last_confirm_date_lteq',
            label: `${this.$t('accountFund.lastConfirmDate')}小于等于`
          }
        ]),
        renderCell: (h, { props: { value } }) => {
          return <bean-table value={value} columns={accountFundColumns} />;
        }
      },
      'is_staff',
      'kind',
      'agent_target',
      'referrer',
      { key: 'certificate_end_date', minWidth: 120 },
      {
        key: 'phone',
        width: 120,
      },
      {
        key: 'email',
        width: 200,
      },
      'address',
      'city',
      'status',
      'reject_reason',
      'login_activities_count',
      type === 'show' && 'personas',
      type === 'show' && abilityService.can('accounts.update_remark') && 'remark',
      type === 'show' && 'audio_or_video_recording_file',
      type === 'show' && 'bank_card_scan_file',
      type === 'show' && 'fund_contract',
      type === 'show' && 'number_scan_file',
      type === 'show' && 'proof_of_assets',
      type === 'show' && 'qualified_investor_commitment_letter',
      type === 'show' && 'risk_assessment_file',
      type === 'show' && 'risk_disclosure',
      type === 'show' && 'supplementary_agreement_to_fund_contract',
      type === 'show' && 'other_files',
      {
        key: 'created_at',
        width: 160,
      },
      {
        key: 'updated_at',
        width: 160,
      }
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const fileDefaultRenderCell = {
      renderCell: {
        props: {
          accept: 'application/pdf, application/zip',
          type: 'application',
          size: 20
        }
      }
    }

    const array = [
      'type',
      data.type === 'PersonalAccount' && 'is_staff',
      data.type === 'ProductAccount' && 'kind',
      data.type === 'AgentAccount' && {
        key: 'agent_target_id',
        renderCell: this.agentTargetIdRenderCell
      },
      'referrer',
      'number',
      (data.type === 'PersonalAccount' || data.type === 'AgentAccount') && 'user_id',
      'certificate_end_date',
      'risk_assessment_level',
      'name',
      'phone',
      'email',
      'address',
      'city',
      _.merge({}, fileDefaultRenderCell, { key: 'audio_or_video_recording_file' }),
      _.merge({}, fileDefaultRenderCell, { key: 'bank_card_scan_file' }),
      _.merge({}, fileDefaultRenderCell, { key: 'fund_contract' }),
      _.merge({}, fileDefaultRenderCell, { key: 'number_scan_file' }),
      _.merge({}, fileDefaultRenderCell, { key: 'proof_of_assets' }),
      _.merge({}, fileDefaultRenderCell, { key: 'qualified_investor_commitment_letter' }),
      _.merge({}, fileDefaultRenderCell, { key: 'risk_assessment_file' }),
      _.merge({}, fileDefaultRenderCell, { key: 'risk_disclosure' }),
      _.merge({}, fileDefaultRenderCell, { key: 'supplementary_agreement_to_fund_contract' }),
      _.merge({}, fileDefaultRenderCell, {
        key: 'other_files',
        renderCell: {
          props: {
            limit: 5,
          }
        }
      }),
      'personas',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'formal_accounts.edit', params: { id: row.id } },
          can: 'accounts.update'
        }
      },
      {
        component: 'routeButton',
        props: {
          label: this.$t('model.trade'),
          to: { name: 'trades.index', query: { account_id_eq: row.trade_account_id } },
          can: 'trades.read'
        }
      },
      _.includes(['pending', 'rejected'], row.status) && {
        component: 'confirmButton',
        props: {
          label: '同意',
          type: 'primary',
          can: 'accounts.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/accounts/${row.id}/approve`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.status === 'pending' && {
        component: 'dialogFormButton',
        props: {
          label: '拒绝',
          can: 'accounts.update',
          value: row,
          columns: formColumnsExtend([
            {
              key: 'reject_reason',
              renderCell: {
                required: true,
                hint: '微信订阅消息仅能显示前20个字符'
              }
            }
          ], { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/accounts/${row.id}/reject`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
      row.status === 'rejected' && {
        component: 'confirmButton',
        props: {
          label: '重新审核',
          type: 'primary',
          can: 'accounts.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/accounts/${row.id}/pend`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'dialogFormButton',
        props: {
          label: '备注',
          can: 'accounts.update_remark',
          value: row,
          columns: formColumnsExtend([
            {
              key: 'remark',
              renderCell: {
                required: true
              }
            }
          ], { data: row, type: 'edit' }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/accounts/${row.id}/update_remark`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
      // 正式都有account_funds关联，不应该能删除
      // {
      //   component: 'confirmButton',
      //   props: {
      //     label: this.$t('destroy'),
      //     type: 'danger',
      //     can: 'accounts.destroy'
      //   },
      //   on: {
      //     confirm: () => remove(row.id)
      //   }
      // }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
          await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>
    ];
  }

  async handleSubmit({ data }) {
    try {
      this.formLoading = true;
      let body = data;
      const action = this.type === 'new' ? 'post' : 'put';
      let path = '/accounts'
      if (this.type === 'edit') {
        path = `/accounts/${body.id}`
      }

      const submitResult = await this.$request[action](path, body);
      const message = this.type === 'new' ? this.$t('bean.createSuccess') : this.$t('bean.updateSuccess');
      this.$message.success(message);
      const id = _.get(submitResult, 'id') || _.get(data, 'id');

      if (id) {
        this.$router.push(linkTo({ item: submitResult || data }));
      }
    } finally {
      this.formLoading = false;
    }
  }
}

export const route = [
  {
    path: '/formal_accounts',
    name: 'formal_accounts.index',
    component: FormalAccounts,
    props: {
      type: 'index',
    }
  },
  {
    path: '/formal_accounts/:id',
    name: 'formal_accounts.show',
    component: FormalAccounts,
    props: {
      type: 'show',
    }
  },
  {
    path: '/formal_accounts/:id/edit',
    name: 'formal_accounts.edit',
    component: FormalAccounts,
    props: {
      type: 'edit'
    }
  }
]
</script>
